<div class="tree-container">
  <p-tree #tree [value]="_folders" class="tree-component" [filter]="true" filterMode="lenient" filterPlaceholder="search"
          selectionMode="single" [(selection)]="selectedNode" [contextMenu]="canModify ? cm : null"
          [draggableNodes]="canModify && (PermissionEnum.FOLDERS_MOVE_MAPS | hasPermission | async)"
          [droppableNodes]="canModify && (PermissionEnum.FOLDERS_MOVE_MAPS | hasPermission | async)" [filteredNodes]="_filteredFolders"
          draggableScope="self" droppableScope="self" (onNodeContextMenuSelect)="nodeSelected($event.node)" (onNodeDrop)="onNodeDrop($event)">
    <ng-template let-node pTemplate="default">
      <div class="d-flex align-items-start ">
        <div class="d-flex flex-column align-items-center">
          {{ node.label }}
        </div>
        @if (!node.data.hasOwnProperty("folders")) {
          <span #targetButton class="pi pi-ellipsis-v map-options" (click)="nodeSelected(node)"></span>
          <p-contextMenu [target]="targetButton" [model]="contextItems" [appendTo]="'body'" triggerEvent="click"
          ></p-contextMenu>
        }
      </div>


    </ng-template>
    <ng-template let-node pTemplate="error">
      <span>{{ node.label }}</span>
    </ng-template>
    <ng-template let-node pTemplate="inProgress">
      <span pTooltip="Map is being processed.">{{ node.label }}</span>
    </ng-template>
  </p-tree>

  @if (canModify) {
    <button
      class="floating-save"
      pButton
      [rounded]="true"
      [disabled]="!_hasChangesToSave"
      *appHasAccess="{ permissions: [PermissionEnum.FOLDERS_ADD_NEW, PermissionEnum.FOLDERS_MOVE_MAPS, PermissionEnum.FOLDERS_EDIT, PermissionEnum.FOLDERS_DELETE]}"
      (click)="saveFolderConfig()"
      pTooltip="Save changes">
      <i class="pi pi-save" pButtonIcon></i>
    </button>
    <button
      class="floating-add"
      pButton
      (click)="addRootFolder()"
      [rounded]="true"
      *appHasAccess="{ permissions: [PermissionEnum.FOLDERS_ADD_NEW, PermissionEnum.FOLDERS_MOVE_MAPS, PermissionEnum.FOLDERS_EDIT, PermissionEnum.FOLDERS_DELETE]}"
      pTooltip="Add Folder">
      <i class="pi pi-plus" pButtonIcon></i>
    </button>
  } @else {
    <button
      class="floating-save cancel-selection"
      pButton
      [rounded]="true"
      (click)="cancelSelection()"
      pTooltip="Cancel">
      <i class="pi pi-times" pButtonIcon></i>
    </button>
    <button
      class="floating-add"
      pButton
      [disabled]="!selectedNode"
      (click)="confirmSelection()"
      [rounded]="true"
      pTooltip="Acceept">
      <i class="pi pi-check" pButtonIcon></i>
    </button>
  }

  <p-contextmenu #cm [model]="contextItems" appendTo="body"></p-contextmenu>
</div>

<p-dialog [header]="isNewFolder ? 'New Folder' : 'Edit Folder'" [modal]="true" [(visible)]="isEditVisible"
          [style]="{ width: '25rem' }">
  <form class="form" #dataForm="ngForm">
    <div class="flex items-center gap-4 mb-4">
      <div class="form-group">
        <label for="folderTxt">Folder</label>
        <input class="form-control" type="text" pInputText id="folderTxt"
               name="folder" required [(ngModel)]="folderName" appTrimInput/>
      </div>
    </div>

    <div class="d-flex flex-row justify-content-end gap-1">
      <p-button styleClass="p-button-primary primary p-button-sm" [label]="'Save'"
                (onClick)="saveFolderChanges()" [disabled]="!dataForm.form.valid"></p-button>
      <p-button styleClass="p-button-primary secondary p-button-sm" [label]="'Cancel'"
                (onClick)="isEditVisible=false"></p-button>
    </div>

  </form>
</p-dialog>

<p-dialog [header]='"Errors"' [modal]="true" [(visible)]="isErrorsVisible"
          [style]="{ width: '50rem' }">
  <p-table [value]="rowErrors" [scrollable]="true" scrollHeight="400px" [tableStyle]="{'min-width': '50rem'}">
    <ng-template #header>
        <tr>
            <th style="width: 10rem;;">Row number</th>
            <th>Error</th>
        </tr>
    </ng-template>
    <ng-template #body let-error>
        <tr>
            <td>{{error.row}}</td>
            <td>{{error.message}}</td>
        </tr>
    </ng-template>
</p-table>
</p-dialog>

<p-confirmdialog/>

